import AnnouncementBar from "./components/AnnouncementBar";
import HeroSection from "./components/HeroSection";
import BestSellers from "./components/BestSellers";
import CollectionBanner from "./components/CollectionBanner";
import NewInSection from "./components/NewInSection";
import PreFallBanner from "./components/PreFallBanner";
import FeaturesSection from "./components/FeaturesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import Navbar from "../../feature/Navbar";
import Footer from "../../feature/Footer";
import WhatsAppButton from "../../feature/WhatsAppButton";

export default function Home() {
  return (
    <div
      className="min-h-screen bg-white"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      <AnnouncementBar />
      <Navbar />

      <main>
        <HeroSection />
        <CollectionBanner />
        <BestSellers />
        <TestimonialsSection />
        <NewInSection />
        <PreFallBanner />
        <FeaturesSection />
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}